import { render, staticRenderFns } from "./PingButton.vue?vue&type=template&id=ce80d73a"
import script from "./PingButton.vue?vue&type=script&lang=ts"
export * from "./PingButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports